const DeleteIcon = ({ className, style, color = "#2c2c2c" }) => {
    return (
      <svg
        className={className}
        style={style}
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        width="200"
        height="200"
      >
        <path d="M844.8 302.933333 213.333333 302.933333c-17.066667 0-34.133333 12.8-34.133333 34.133333S196.266667 366.933333 213.333333 366.933333l68.266667 0 46.933333 439.466667c0 17.066667 17.066667 29.866667 29.866667 29.866667l345.6 0c17.066667 0 29.866667-12.8 29.866667-29.866667l46.933333-439.466667 59.733333 0c17.066667 0 34.133333-12.8 34.133333-34.133333S861.866667 302.933333 844.8 302.933333zM674.133333 768 388.266667 768l-42.666667-401.066667 371.2 0L674.133333 768z" fill={color}></path>
        <path d="M392.533333 256l273.066667 0c17.066667 0 34.133333-12.8 34.133333-34.133333S682.666667 192 665.6 192L392.533333 192c-17.066667 0-34.133333 12.8-34.133333 34.133333S375.466667 256 392.533333 256z" fill={color}></path>
        <path d="M576 669.866667C576 669.866667 576 669.866667 576 669.866667c21.333333 0 34.133333-12.8 34.133333-29.866667l21.333333-192c0-17.066667-8.533333-34.133333-29.866667-34.133333-17.066667-4.266667-34.133333 8.533333-34.133333 29.866667l-21.333333 192C546.133333 652.8 558.933333 669.866667 576 669.866667z" fill={color}></path>
      </svg>
    );
  };

export default DeleteIcon;
  